import type { ApiClient, ApiService } from '@/lib/apiClient'
import { toApiError } from '@/lib/signalRApiService/utils'

interface Args {
  customerId: string
  signalRConnectionId: string
  userId: string
  groupName: string
  email: string
}

type Response = void

export type AddUserToGroupApiService = ApiService<Args, Response>

const createAddUserToGroupApiService =
  (apiClient: ApiClient): AddUserToGroupApiService =>
  ({ signalRConnectionId, userId, groupName, email }) =>
    apiClient
      .post(`addToGroup`, {
        connectionId: signalRConnectionId,
        personId: userId,
        groupName,
        email,
      })
      .then(_ => undefined)
      .catch(error => Promise.reject(toApiError(error)))

export default createAddUserToGroupApiService
